import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import d3 from 'd3'
import i18n from './i18n'


// var debug = false
var debug = false

Vue.config.productionTip = !debug
Vue.prototype.$http = axios

if (debug){
  Vue.prototype.$API_URL = "http://localhost:9090/api/";
  Vue.prototype.$DOMAIN_URL = "https://pumpselector.maxisu.com/"; 
}else{
  Vue.prototype.$API_URL = "https://pumpselector.maxisu.com/api/";
  Vue.prototype.$DOMAIN_URL = "https://pumpselector.maxisu.com/"; 
  // Vue.prototype.$API_URL = "http://pumpselector.yazilimsalcozumler/api/";
} 

Vue.prototype.$DEVELOPER_URL = "https://yazilimsalcozumler.com/api/pumpselection/";

window.myvue = new Vue({
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
